import { useRef } from "react";
import { useCopyInputSelectionToClipboard } from "../hooks/useCopyInputSelectionToClipboard";
import Btn from "./Btn";


// DEFAULT COMPONENT
const DisplayExportFieldWidget = (props) => {
  const exportRef = useRef();
  const { _copy } = useCopyInputSelectionToClipboard();
  const {
    label,
    name,
    val,
    _val_typeof,
    error,
    errorMsg,
    btnCopyEnabled,
  } = props;

  let extraClass = '';
  if (typeof props.extraClass === 'string' && props.extraClass !== '') {
    extraClass = ' ' + props.extraClass;
  }

  return (
    <>
      <div className={("card-export-read-only-form" + extraClass)}>
        {
          error === true ? (
            <div><p className="text-red"><b>{errorMsg}</b></p></div>
          ) : (
            <>
              <div className="uniformcompo__field uniformcompo__field--no-yard">
                <label>{label}</label>
                <textarea
                  readOnly
                  className="export-field"
                  name={name}
                  value={val}
                  ref={exportRef}
                />
              </div>
              {
                (btnCopyEnabled === true || props.extraBtnsElement) && (
                  <div className="card-footer-btns">
                    <Btn
                      title="Copy"
                      tooltip="Copy to clipboard"
                      inline
                      outline
                      circle
                      btnSmallWithTitle
                      i="fa fa-copy"
                      handleClick={(e) => { _copy(e, exportRef); }}
                    />
                    {
                      props.extraBtnsElement && (
                        <>{props.extraBtnsElement}</>
                      )
                    }
                  </div>
                )
              }
            </>
          )
        }
      </div>
    </>
  );
};

export default DisplayExportFieldWidget;